export { default } from './CitedText';
